<template>
  <v-container fluid>
    <material-card icon="mdi-google-classroom" title="All Trainings">
      <v-card-actions v-if="isWrite">
        <router-link slot="right" :to="{ name: 'NewOnlineTraining' }">
          <v-btn color="accent" elevation="1" absolute right top> <v-icon left>mdi-plus</v-icon>Schedule Training </v-btn>
        </router-link>
      </v-card-actions>
      <v-card flat class="pb-4">
        <v-card-text class="pt-0 pr-1">
          <v-tabs @change="applyStatusFilter" v-model="tab">
            <v-tab key="Upcoming Trainings"> Upcoming Trainings </v-tab>
            <v-tab key="Previous Trainings"> Previous / Cancelled Training </v-tab>
          </v-tabs>
          <v-divider class="my-0"></v-divider>
        </v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item key="Upcoming Trainings">
            <v-card>
              <v-card-title>
                <v-row>
                  <v-col cols="9">
                    <v-select
                      @change="getAllTrainingByTrainersList()"
                      style="max-width:250px;"
                      class="pl-2"
                      label="Type"
                      :items="trainingTypeList"
                      v-model="selectedTypes"
                      item-text="text"
                      item-value="value"
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="search" right append-icon="mdi-magnify" style="max-width:350px;" label="Search" single-line hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table :headers="tableHeaders" :search="search" :items="TypeStatusFilteredList">
                <template v-slot:item.trainingDate="{ item }">
                  {{ formatDate(item.fromDate) + ' - ' + formatDate(item.toDate) }}
                </template>
                <template v-slot:item.registrations="{ item }">
                  {{ item.totalRegistrations.length + '/' + item.batchSize }}
                </template>
                <template v-slot:item.locationCenterAddress="{ item }">
                  {{ item.locationCenterAddress || 'NA' }}
                </template>
                <template v-slot:item.fromTime="{ item }">
                  {{ formatTime(item.fromTime) }}
                </template>
                <template v-slot:item.toTime="{ item }">
                  {{ formatTime(item.toTime) }}
                </template>
                <template v-slot:item.status="{ item }">
                  {{ 'Upcoming' }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn v-if="subModules.JoinMeeting && item.type === 'online' && item.selfInvitation" :disabled="isJoineMeetingDisable(item)" @click="JoinMeeting(item.trainingOnlineMeetings)" class="px-2 ml-1 ma-1" color="info" min-width="0" small
                    >Join Meeting
                  </v-btn>
                  <v-btn v-if="subModules.EndMeeting && item.type === 'online'" :disabled="isJoineMeetingDisable(item)" @click="endMeetingConfirm(item.trainingOnlineMeetings)" class="px-2 ml-1 ma-1" color="error" min-width="0" small
                    >End Meeting
                  </v-btn>
                  <router-link v-if="subModules.EditMeeting" :to="{ name: 'editTeacherTraining', params: { id: item.id } }">
                    <v-btn :disabled="!item.isActive" class="px-2 ml-1 ma-1" color="info" min-width="0" small>View/Edit </v-btn>
                  </router-link>
                  <router-link v-if="subModules.RegisterStaff" slot="right" :to="{ name: 'RegisterStaff', params: { trainingID: item.id } }">
                    <v-btn :disabled="!item.isActive" class="px-2 ml-1 ma-1" color="info" min-width="0" small>Register Staff/Edit </v-btn>
                  </router-link>
                    <v-btn v-if="subModules.MarkAttendance && !item.isAttendanceLocked" :disabled="item.totalRegistrations.length === 0" class="px-2 ml-1 ma-1" color="info" min-width="0" small @click="markAttendance(item.id)">Mark Attendance </v-btn>
                  <router-link v-if="subModules.ViewRegistrations" slot="right" :to="{ name: 'viewTrainingRegistrationDetails', params: { id: item.id } }">
                    <v-btn class="px-2 ml-1 ma-1" color="info" min-width="0" small>View Registrations </v-btn>
                  </router-link>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item key="Previous Trainings">
            <v-card>
              <v-card-title>
                <v-row>
                  <v-col cols="9">
                    <v-select
                      @change="getAllTrainingByTrainersList()"
                      class="pl-2"
                      label="Type"
                      style="max-width:250px;"
                      :items="trainingTypeList"
                      v-model="selectedTypes"
                      item-text="text"
                      item-value="value"
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="search" right append-icon="mdi-magnify" style="max-width:350px;" label="Search" single-line hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table @current-items="getFiltered" :headers="tableHeaders" :search="search" :items="TypeStatusFilteredList">
                <template v-slot:item.trainingDate="{ item }">
                  {{ formatDate(item.fromDate) + ' - ' + formatDate(item.toDate) }}
                </template>
                <template v-slot:item.registrations="{ item }">
                  {{ item.totalRegistrations.length + '/' + item.batchSize }}
                </template>
                 <template v-slot:item.locationCenterAddress="{ item }">
                  {{ item.locationCenterAddress || 'NA' }}
                </template>
                <template v-slot:item.status="{ item }">
                  {{ item.isActive ? 'Completed' : 'Cancelled' }}
                </template>
                <template v-slot:item.action="{ item }">
                  <!--Cancelled training will not have actions-->
                  <div v-if="item.isActive">
                    <router-link slot="right" v-if="subModules.MarkAttendance && !item.isAttendanceLocked" :to="{ name: 'markAttendance', params: { trainingID: item.id } }">
                      <v-btn :disabled="item.totalRegistrations.length === 0" class="px-2 ml-1 ma-1" color="info" min-width="0" small>Mark Attendance </v-btn>
                    </router-link>
                    <router-link v-if="subModules.ShareFeedback && item.isShareFeedback" slot="right" :to="{ name: 'trainerFeedback', params: { trainingID: item.id } }">
                      <v-btn class="px-2 ml-1 ma-1" color="info" min-width="0" small>Share Feedback </v-btn>
                    </router-link>

                    <v-btn v-if="subModules.FeedbackReport" :disabled="item.averageScore === null" class="px-2 ml-1 ma-1" color="info" min-width="0" small @click="feedbackReport(item.id,item.trainingTrainerMaps[0].trainerUserID)">Feedback Report </v-btn>
                    <v-btn v-if="!item.isShareFeedback && subModules.ShareFeedback" :disabled="!item.isShareFeedback" class="px-2 ml-1 ma-1" color="info" min-width="0" small>Feedback Shared </v-btn>
                    <router-link
                      slot="right"
                      v-if="subModules.ViewAttendance && item.isAttendanceLocked"
                      :disabled="!item.isActive"
                      :to="{ name: 'viewTrainingAttendanceDetails', params: { trainingID: item.id } }"
                    >
                      <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>View Attendance </v-btn>
                    </router-link>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import stores from '@/stores'
export default {
  name: 'OnlineClassList',
  components: { MaterialCard },
  data () {
    return {
      subModules: {
        JoinMeeting: this.checkModuleAccess('JoinMeeting'),
        EndMeeting: this.checkModuleAccess('EndMeeting'),
        RegisterStaff: this.checkModuleAccess('RegisterStaff'),
        EditMeeting: this.checkModuleAccess('EditMeeting'),
        ShareFeedback: this.checkModuleAccess('ShareFeedback'),
        MarkAttendance: this.checkModuleAccess('MarkAttendance'),
        ViewRegistrations: this.checkModuleAccess('ViewRegistrations'),
        ViewAttendance: this.checkModuleAccess('ViewAttendance'),
        FeedbackReport: this.checkModuleAccess('FeedbackReport')
      },
      tab: null,
      search: '',
      tableHeaders: [
        { text: 'Training Title', value: 'title', sortable: false },
        { text: 'Date', value: 'trainingDate', sortable: false },
        { text: 'Registrations', value: 'registrations', sortable: false },
        { text: 'Location', value: 'locationCenterAddress', sortable: false },
        { text: 'From Time', value: 'fromTime', sortable: false },
        { text: 'To Time', value: 'toTime', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Action', value: 'action', sortable: false }
      ],
      filterArr: [],
      filters: {
        type: []
      },
      trainingByTrainersList: [],
      upcomingTrainingByTrainersList: [],
      previousTrainingByTrainersList: [],
      cancelledTrainingByTrainersList: [],
      statusFilteredList: [],
      currentDate: moment.now(),
      trainingTypeList: [
        { text: 'All', value: '', sortable: false },
        { text: 'Online', value: 'online', sortable: false },
        { text: 'Offline', value: 'offline', sortable: false }
      ],
      selectedTypes: '',
      TypeStatusFilteredList: [],
      isWrite: false,
      user: stores.user.me
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  created: function () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    console.log('User Id', stores.user.me.id)
  },
  mounted: async function () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getFiltered (e) {
      this.filterArr = e
    },
    columnValueList (val) {
      return this.trainingByTrainersList.map(d => d[val])
    },
    onFranchiseeChange: async function () {
      if (this.franchisee) {
        this.franchiseeID = this.franchisee.id
      } else {
        this.franchiseeID = ''
      }
      await this.getAllTrainingByTrainersList()
    },
    getAllTrainingByTrainersList: async function () {
      try {
        let filters = {}
        filters.franchiseeID = this.franchiseeID
        filters.type = this.selectedTypes
        const { data } = await http.post(`${constants.API_URL}/api/teacher-training/get-all-trainings`, filters)
        this.trainingByTrainersList = data
        this.upcomingTrainingByTrainersList = data.upcoming
        const types = [...new Set(this.upcomingTrainingByTrainersList.map(obj => obj.type))]
        this.trainingTypeList = _.concat(this.trainingTypeList, types)
        this.applyStatusFilter()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    applyStatusFilter () {
      this.selectedType = 'All'
      let type = ''
      if (this.tab === 0) {
        type = 'upcoming'
        this.statusFilteredList = this.trainingByTrainersList.upcoming
      } else if (this.tab === 1) {
        type = 'previous'
        this.statusFilteredList = this.trainingByTrainersList.previous.map(prev => {
          prev.isShareFeedback = true
          if (prev.teacherEnrollment.length > 0) {
            if (prev.teacherEnrollment[0].teacherFeedback.length > 0) {
              // User already given feedback
              prev.isShareFeedback = false
            }
          }
          return prev
        })
      } else if (this.tab === 2) {
        type = 'cancelled'
        this.statusFilteredList = this.trainingByTrainersList.cancelled
      }
      this.applyTypeFilter(type)
    },
    applyTypeFilter (type) {
      if (!_.isEqual(this.selectedType, 'All')) {
        if (_.isEqual(type, 'upcoming')) {
          this.TypeStatusFilteredList = this.statusFilteredList.filter(map => {
            return map.type === this.selectedType
          })
        }
        if (_.isEqual(type, 'previous')) {
          this.TypeStatusFilteredList = this.statusFilteredList.filter(map => {
            return map.type === this.selectedType
          })
        }
        if (_.isEqual(type, 'cancelled')) {
          this.TypeStatusFilteredList = this.statusFilteredList.filter(map => {
            return map.type === this.selectedType
          })
        }
      } else {
        this.TypeStatusFilteredList = this.statusFilteredList
      }
    },
    isJoineMeetingDisable (training) {
      let currentTime = moment().format('HH:mm:ss')
      let currentDate = moment()
      let fromDate = moment(training.fromDate).format('YYYY-MM-DD')
      let toDate = moment(training.toDate).format('YYYY-MM-DD')
      if (currentDate.isBefore(fromDate)) {
        return true
      }
      if (currentDate.isAfter(toDate)) {
        return true
      }
      if (this.diffTime(training.fromTime, currentTime) > 15) {
        // More than 10 min for the meeting
        return true
      }
      if (this.diffTime(training.toTime, currentTime) <= 0) {
        // Current time past the end time
        return true
      }
      if (training.trainingOnlineMeetings[0].status === constants.TEACHER_TRAINING_STATUS.completed || training.trainingOnlineMeetings[0].status === constants.TEACHER_TRAINING_STATUS.cancelled) {
        return true
      }
      return false
    },
    JoinMeeting: async function (onlineMeetings) {
      try {
        if (_.isArray(onlineMeetings)) {
          if (onlineMeetings.length > 0) {
            let meetingId = onlineMeetings[0].id
            this.loadingComponent = this.$buefy.loading.open()
            const { data } = await http.get(`${constants.API_URL}/api/teacher-training/get-url?meetingID=${meetingId}`)
            this.loadingComponent.close()
            if (data) {
              this.$router.push({ name: 'joinTrainingMeeting', params: { referenceID: data.referenceID } })
            }
          } else {
            return this.errMsg(`Meeting details not founds!`)
          }
        } else {
          return this.errMsg(`Meeting details not found!`)
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    EndMeeting: async function (onlineMeetings) {
      try {
        if (_.isArray(onlineMeetings)) {
          if (onlineMeetings.length > 0) {
            let meetingId = onlineMeetings[0].id
            this.loadingComponent = this.$buefy.loading.open()
            await http.get(`${constants.API_URL}/api/teacher-training/end?meetingID=${meetingId}`)
            this.loadingComponent.close()
            await this.onFranchiseeChange()
            this.$buefy.toast.open('Meeting ended!')
          } else {
            return this.errMsg(`Meeting details not founds!`)
          }
        } else {
          return this.errMsg(`Meeting details not found!`)
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    endMeetingConfirm (onlineMeetings) {
      this.$buefy.dialog.confirm({
        title: 'End Meeting',
        message: 'Are you sure you want to <b>END</b> the meeting? This action cannot be undone.',
        confirmText: 'End Meeting',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.EndMeeting(onlineMeetings)
        }
      })
    },
    markAttendance (trainingId) {
      this.$router.push({ name: 'markAttendance', params: { trainingID: trainingId } })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    feedbackReport (trainingId, trainerId) {
      this.$router.push({ name: 'indiviualTrainerFeedbackReport', params: { trainingID: trainingId, trainerID: trainerId } })
    },
    diffTime (time1, time2) {
      if (time1.length > 5) {
        time1 = moment(time1, 'HH:mm:ss')
        time2 = moment(time2, 'HH:mm:ss')
      } else {
        time1 = moment(time1, 'HH:mm')
        time2 = moment(time2, 'HH:mm')
      }
      let diffInMin = time1.diff(time2, 'minute')
      return diffInMin
    },
    // convert 24 hour to 12 hour using moment js
    formatTime (time) {
      return moment(time, 'HH:mm:ss').format('hh:mm A')
    }
  }
}
</script>
